module.exports = __webpack_public_path__ + "img/katarina11.7415b1e7.jpg";